import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getReportsListingData, getGeneratedReports } from "src/api/sp";
import { resetStore } from "src/store/actions";
import { ReportsInitialState } from "../interface";

export const fetchReportsListingData = createAsyncThunk(
  "reports/fetchReportsListingData",
  ({ userEmail, storeId }: { userEmail: string; storeId: string }) =>
    getReportsListingData({ userEmail, storeId })
);

export const fetchGeneratedReports = createAsyncThunk(
  "reports/fetchGeneratedReports",
  (payload: any) => getGeneratedReports(payload)
);

const initialState: ReportsInitialState = {
  loading: "loading",
  reportLoading: "loading",
  action: "idle",
  reportsListData: [],
  generatedReports: [],
  reportView: "all"
};

const rowIndex = (reports: any, rowId: any) => {
  return reports.findIndex((rowData: any) => rowData.id == rowId);
};

const ReportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setAction(state, action) {
      state.action = action.payload;
    },
    setReportView(state, action) {
      state.reportView = action.payload;
    },
    setIsNewFalse(state, rowId) {
      state.generatedReports.find((rowData) => {
        return rowData.id == rowId.payload;
      }).isNew = false;
    },
    setPDFLoader(state, data) {
      const idx = rowIndex(state.generatedReports, data.payload.id);
      if (idx !== -1) {
        state.generatedReports[idx].pdfLoader = data.payload.value;
      }
    },
    setDeleteLoader(state, data) {
      const idx = rowIndex(state.generatedReports, data.payload.id);
      if (idx !== -1) {
        state.generatedReports[idx].deleteLoader = data.payload.value;
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchReportsListingData.pending, (state, action) => {
        state.loading = "loading";
      })
      .addCase(fetchReportsListingData.fulfilled, (state, action) => {
        state.reportsListData = action.payload.data;
        state.loading = "idle";
      })
      .addCase(fetchReportsListingData.rejected, (state) => {
        state.reportsListData = initialState.reportsListData;
        state.loading = "error";
      })
      .addCase(fetchGeneratedReports.pending, (state, _action) => {
        if (!_action.meta?.arg?.isLoading) {
          state.loading = "idle";
          state.reportLoading = "idle";
        } else {
          state.loading = "pending";
          state.reportLoading = "pending";
          state.generatedReports = initialState.generatedReports;
        }
      })
      .addCase(fetchGeneratedReports.fulfilled, (state, action) => {
        state.generatedReports = action.payload.data?.generatedReportList || [];
        state.generatedReports.forEach((rowData) => {
          rowData.pdfLoader = false;
          rowData.deleteLoader = false;
        });
        state.recordsCount = action.payload.data?.recordsCount || 0;
        state.loading = "idle";
        state.reportLoading = "idle";
      })
      .addCase(fetchGeneratedReports.rejected, (state) => {
        state.generatedReports = initialState.generatedReports;
        state.loading = "error";
        state.reportLoading = "error";
      });
  }
});

export const {
  setLoading,
  setAction,
  setReportView,
  setIsNewFalse,
  setPDFLoader,
  setDeleteLoader
} = ReportsSlice.actions;

export default ReportsSlice.reducer;
